import React from 'react';
import { motion } from 'framer-motion';
import { Home, Phone, Mail } from 'lucide-react';
export function ListingsComingSoon({
  area = 'Las Vegas'
}: {
  area?: string;
}) {
  return <section className="py-24 px-6 bg-warmGray border-t border-warmGray-dark" data-id="element-209">
      <div className="max-w-4xl mx-auto text-center" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-211">
          <div className="w-16 h-16 rounded-full border-2 border-gold flex items-center justify-center mx-auto mb-8" data-id="element-212">
            <Home className="w-7 h-7 text-gold" data-id="element-213" />
          </div>

          <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-214">
            Coming Soon
          </span>
          <h2 className="text-4xl font-serif text-charcoal mb-6" data-id="element-215">
            Live Listings for <span className="italic" data-id="element-216">{area}</span>
          </h2>
          <p className="text-lg text-charcoal-light font-light leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-217">
            We're integrating live MLS listings so you can browse real homes
            with accurate photos, prices, and details. In the meantime, Jenny
            can send you current listings that match exactly what you're looking
            for.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-218">
            <a href="tel:+18583978218" className="inline-flex items-center gap-3 bg-gold text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-gold-dark transition-colors duration-300" data-id="element-219">
              <Phone className="w-4 h-4" data-id="element-220" />
              (858) 397-8218
            </a>
            <a href="mailto:jenny@jennygong.com" className="inline-flex items-center gap-3 border border-charcoal text-charcoal px-8 py-4 uppercase tracking-widest text-sm hover:bg-charcoal hover:text-white transition-colors duration-300" data-id="element-221">
              <Mail className="w-4 h-4" data-id="element-222" />
              Email Jenny
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}